import {TASKMANAGE} from 'Constants/ActionTypes';

const {
  SET_TASK_QUESTIONNAIRE_SEARCH_DATA,
  GET_TASK_QUESTIONNAIRE_CONNECT_PIE,
  GET_TASK_QUESTIONNAIRE_ANSWER_BAR,
  GET_TASK_QUESTIONNAIRE_RESULT,
  SET_TASK_QUESTIONNAIRE_PAGE_STATUS,
  POST_QUESTIONNAIRE_PAGE_EXPORT,
  GET_TASK_QUESTIONNAIRE_HEAD,
  SET_TABLEHEAD_SEARCH_DATA,
} = TASKMANAGE;
// 通用前缀
const url = '/robot';

const actions = {
  // 任务管理-问卷统计-设置搜索条件
  setSearchData(data) {
    return {
      type: SET_TASK_QUESTIONNAIRE_SEARCH_DATA,
      data,
    };
  },
  // 任务管理-问卷统计-pie-接通情况
  getQuestionNaireConnect(data) {
    return {
      type: GET_TASK_QUESTIONNAIRE_CONNECT_PIE,
      payload: {
        request: {
          method: 'post',
          url: `${url}/questionnaire/conn`,
          data,
        },
      },
    };
  },
  // 任务管理-问卷统计-bar-回答情况
  getQuestionNaireAnswer(data) {
    return {
      type: GET_TASK_QUESTIONNAIRE_ANSWER_BAR,
      payload: {
        request: {
          method: 'post',
          url: `${url}/questionnaire/answer`,
          data,
        },
      },
    };
  },
  // 任务管理-问卷统计-设置搜索条件
  setHeadSearchData(data) {
    return {
      type: SET_TABLEHEAD_SEARCH_DATA,
      data,
    };
  },
  // 任务管理-问卷统计-table-表头
  getTableHead(data) {
    return {
      type: GET_TASK_QUESTIONNAIRE_HEAD,
      payload: {
        request: {
          method: 'post',
          url: `${url}/questionnaire/dialog/record`,
          data,
        },
      },
    };
  },
  // 任务管理-问卷统计-table-任务结果
  getTableList(data) {
    return {
      type: GET_TASK_QUESTIONNAIRE_RESULT,
      payload: {
        request: {
          method: 'post',
          url: `${url}/questionnaire/list`,
          data,
        },
      },
    };
  },
  // 任务管理-问卷统计-设置pageNum与pageSize
  setPageStatus(data) {
    return {
      type: SET_TASK_QUESTIONNAIRE_PAGE_STATUS,
      data,
    };
  },
  // 导出
  exportTask(data) {
    return {
      type: POST_QUESTIONNAIRE_PAGE_EXPORT,
      payload: {
        request: {
          method: 'post',
          url: `${url}/questionnaire/export`,
          data,
        },
      },
    };
  },
};

export default actions;
